import React from "react";
import SubtractIcon from "../../assets/images/SubtractIcon.svg";
import AddIcon from "../../assets/images/AddIcon.svg";
import BandOrderImage from "../../assets/images/band-order.png";

import CloseIcon from "../../assets/images/close-icon.svg";

const ShoppingCartCardItem = ({
  productItem,
  shoppingCartItems,
  storeId,
  setLoadingCost,
  setShoppingCartItems,
  getCartItemsCount,
  orderId,
  baseURL,
  langId,
  catalogId,
  isBOB,
  checkHttpStatus,
  jsonApiHeader,
  setTotalCost,
  refreshCartData,
  isCartLocked,
  translationKey,
  currentFileRequired,
  setIsApplyDiscountButtonEnabled,
  isSelected,
  onCheckboxChange,
}) => {
  const itemCurrency = productItem.currency || "USD";

  const currencyFormatter = new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: itemCurrency,
  });

  const discountValue = parseFloat(productItem?.percentageDiscount);
  const discountPercent = Number.isFinite(discountValue)
    ? discountValue > 1
      ? discountValue
      : discountValue * 100
    : null;
  const listPriceValue = parseFloat(productItem?.listPrice);
  const netUnitPriceValue = Number.isFinite(parseFloat(productItem?.unitPrice))
    ? parseFloat(productItem?.unitPrice)
    : Number.isFinite(listPriceValue)
    ? listPriceValue
    : 0;
  const quantityValue = Number.isFinite(parseFloat(productItem?.quantity))
    ? parseFloat(productItem?.quantity)
    : 0;
  const totalUnitPriceValue = netUnitPriceValue * quantityValue;
  const hasListPrice = Number.isFinite(listPriceValue) && listPriceValue > 0;
  const hasDiscountedPricing =
    hasListPrice && listPriceValue > netUnitPriceValue;
  const hasPromoCode =
    (productItem?.promoCode && productItem.promoCode.trim("").length > 0) ||
    (productItem?.promocode && productItem.promocode.trim("").length > 0);
  const shouldShowListPrice =
    hasListPrice && (hasDiscountedPricing || (discountPercent !== null && discountPercent > 0));
  const bandOrderItems = Array.isArray(productItem?.bandOrderData?.items)
    ? productItem.bandOrderData.items
    : [];
  
  let USDollar = new Intl.NumberFormat("en-UK", {
    style: "currency",
    currency: "GBP",
  });
  let updatedShoppingCartItems = [...shoppingCartItems];
  const splitProductDescription = (string, isMainheader) => {
    if (!string) return null;
    var updatedString = string.replace(`${productItem.partNumber},`, "");
    var splitString = updatedString.split(/,(.*)/s); //splits the string after first comma
    if (isMainheader) {
      return splitString[0];
    }
    return splitString[1];
  };
  async function saveInput(...args) {
    const payloadData = {
      orderItem: [
        {
          orderItemId: args[0].orderItemId,
          quantity: args[0].quantity,
        },
      ],
    };
    const token = document.getElementById("reactWCToken")?.value;
    //  "WCToken": "331732%2Cjo0c34Bm0KJfEN5eCInuixCk15gPDKvTqEZ6Oc7jA%2BSDGrfBoheZX4sHQGvh17cG%2BPN6Pwfc9coliz5mQImIQco1xPTS%2F6V9d0f%2BuHZqfkNGCE0dmgr2amgx7jOPtQPyufeI6ekeOQN%2BbnZVx8qrPN6ZriSkmDLEXk%2F7RCJhmkuITB2zefGmOo5BHLKjJ%2F4czi1WgDqtJ9D1q5UpInTqu%2BiqBqYP0IQmVyoLNMcoUsYajV5diffocCpVRBe3N1ar",
    setLoadingCost(true);
    setShoppingCartItems(updatedShoppingCartItems);
    //331732%2C6DfuWhDNWNOgJv%2FamU45IgnD%2BMRQpFQRL7cNl9EZ8E0%3D
    await fetch(`/wcs/resources/store/${storeId}/cart/@self`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        WCAuthToken: token
          ? token
          : "331732%2CuCQCTk7XVbnjdyVybYHGBu6BZYfl2T6u3NwTI0o4oN0%3D",
      },
      body: JSON.stringify(payloadData),
    })
      .then(async () => {
        const responsegetCartItemsCount = await getCartItemsCount(storeId);
        if (responsegetCartItemsCount.orderId) {
          setLoadingCost(false);
        }
      })

      .catch((error) => {
        console.log("error updating quantity", error);
      });
  }

  const bandFormLink = (bandType, seqId, previousComment, isHeader) => {
    if (!bandType || seqId === null || seqId === undefined) {
      return isHeader ? null : "#";
    }
    const bandTypeWithoutSpaces = String(bandType).replace(/\s/g, "");
    if (isHeader) {
      window.location.href = `${baseURL}LogonForm?page=OrderBands&langId=${langId}&storeId=${storeId}&catalogId=${catalogId}&bands=${bandTypeWithoutSpaces}&selectband=${bandTypeWithoutSpaces}&seqId=${seqId}&orderId=${orderId}&previousComment=${previousComment}`;
    } else {
      return `${baseURL}LogonForm?page=OrderBands&langId=${langId}&storeId=${storeId}&catalogId=${catalogId}&bands=${bandTypeWithoutSpaces}&selectband=${bandTypeWithoutSpaces}&seqId=${seqId}&orderId=${orderId}&previousComment=${previousComment}`;
    }
  };

  const redirectToproductPageLink = (
    productId,
    isBandForm,
    parentCatalogGroupID
  ) => {
    const currentItemFound =
      Array.isArray(parentCatalogGroupID) &&
      parentCatalogGroupID.includes(catalogId);
    if (
      Array.isArray(parentCatalogGroupID) &&
      parentCatalogGroupID.length > 0
    ) {
      const currentCategoryIdWithCatalogId = parentCatalogGroupID.find((id) =>
        id.includes(catalogId)
      );
      if (currentCategoryIdWithCatalogId) {
        const categoryId = currentCategoryIdWithCatalogId.split("_")[1];
        window.location.href = `${baseURL}StoreAppView?langId=${langId}&storeId=${storeId}&catalogId=${catalogId}#/product/${productId}?categoryId=${categoryId}`;
      }
    }
  };

  let timeout;

  const parsePositiveQuantity = (value, fallbackValue = 1) => {
    const parsedValue = parseInt(value, 10);
    if (!Number.isNaN(parsedValue) && parsedValue > 0) {
      return parsedValue;
    }

    const parsedFallback = parseInt(fallbackValue, 10);
    return !Number.isNaN(parsedFallback) && parsedFallback > 0
      ? parsedFallback
      : 1;
  };

  const restoreQuantityInput = (productId, quantity) => {
    const normalizedQuantity = parsePositiveQuantity(quantity);
    const quantityInput = document.getElementById(productId);
    const quantityInputByName = document.getElementsByName(productId)[0];

    if (quantityInputByName) {
      quantityInputByName.setAttribute("value", normalizedQuantity);
    }

    if (quantityInput) {
      quantityInput.value = normalizedQuantity;
    }

    return `${normalizedQuantity}`;
  };

  const updateShoppingCartItemQuantity = (orderID, operation, timer) => {
    clearTimeout(timeout);

    //var updatedCartData = [...shoppingCartItems];
    let itemIndex = shoppingCartItems.findIndex(
      ({ orderItemId }) => orderItemId === orderID
    );

    if (itemIndex < 0) {
      return;
    }

    function performUpdateQty() {
      const currentQuantity = parsePositiveQuantity(
        updatedShoppingCartItems[itemIndex]?.quantity,
        shoppingCartItems[itemIndex]?.quantity
      );

      if (operation == "subtract") {
        return `${Math.max(currentQuantity - 1, 1)}`;
      }
      if (operation == "add") {
        return `${currentQuantity + 1}`;
      }
      if (operation == "delete") {
        return "0";
      } else {
        return `${currentQuantity}`;
      }
    }
    updatedShoppingCartItems[itemIndex] = {
      ...updatedShoppingCartItems[itemIndex],
      quantity: performUpdateQty(),
    };

    restoreQuantityInput(orderID, updatedShoppingCartItems[itemIndex].quantity);

    timeout = setTimeout(
      () =>
        saveInput(
          updatedShoppingCartItems.find(
            ({ orderItemId }) => orderItemId === orderID
          )
        ),
      timer
    );

    let total = 0;
    updatedShoppingCartItems.forEach((currentData) => {
      if (document.getElementById(currentData.orderItemId)) {
        total += parseInt(
          document.getElementById(currentData.orderItemId).value
        );
      }
    }, 0);

    // document.getElementById("item-count").innerHTML = `(${total} items)`;
    //setShoppingCartItems(updatedCartData);
  };

  const updateQuantityWithInput = (value, productId, itemIndex) => {
    if (itemIndex < 0) {
      return;
    }

    updatedShoppingCartItems[itemIndex] = {
      ...updatedShoppingCartItems[itemIndex],
      quantity: value,
    };
  };

  const SaveInputQuantity = (value, productId, itemIndex) => {
    if (isNaN(parseInt(value)) || parseInt(value) <= 0) {
      const restoredQuantity = restoreQuantityInput(
        productId,
        shoppingCartItems[itemIndex]?.quantity
      );
      updatedShoppingCartItems[itemIndex] = {
        ...updatedShoppingCartItems[itemIndex],
        quantity: restoredQuantity,
      };
      return;
    } else {
      const normalizedQuantity = parsePositiveQuantity(value);
      restoreQuantityInput(productId, normalizedQuantity);
      updatedShoppingCartItems[itemIndex] = {
        ...updatedShoppingCartItems[itemIndex],
        quantity: `${normalizedQuantity}`,
      };
      saveInput(updatedShoppingCartItems[itemIndex]);
    }
  };

  const deleteShoppingCartItem = async (product, sequence) => {
    const payloadData = {
      orderItemId: product.orderItemId,
      orderId: orderId,
    };

    setLoadingCost(true);
    if (sequence) {
      updatedShoppingCartItems = updatedShoppingCartItems.filter(
        ({ bandOrderData }) => bandOrderData?.sequence !== sequence
      );
    } else {
      updatedShoppingCartItems = updatedShoppingCartItems.filter(
        ({ orderItemId }) =>
          String(orderItemId) !== String(product.orderItemId)
      );
    }

    const token = document.getElementById("reactWCToken")?.value;
    try {
      await fetch(`/wcs/resources/store/${storeId}/cart/@self/delete_order_item`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          WCAuthToken: token
            ? token
            : "331732%2CuCQCTk7XVbnjdyVybYHGBu6BZYfl2T6u3NwTI0o4oN0%3D",
        },
        body: JSON.stringify(payloadData),
      }).then(checkHttpStatus);

      if (refreshCartData) {
        await refreshCartData();
      } else {
        setShoppingCartItems(updatedShoppingCartItems);
        await getCartItemsCount(storeId);
      }
    } catch (error) {
      console.log("error deleting cart item", error);
    } finally {
      setLoadingCost(false);
    }
  };

  const removeDiscountCodeHandler = async (orderItemId) => {
    const runAsUserId = document.getElementById("runAsUserId")?.value;

    let removeDiscountObj = {
      langId,
      storeId,
      catalogId,
      runAsUserId,
      calculateOrder: "1",
      orderItemId_1: orderItemId,
      itemPriceCode_1: "",
    };

    const token = document.getElementById("reactWCToken")?.value;

    const removePromoResponse = await fetch(
      `/wcs/resources/store/${storeId}/shopcart/removeDiscountCode`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          WCAuthToken: token
            ? token
            : "331732%2CuCQCTk7XVbnjdyVybYHGBu6BZYfl2T6u3NwTI0o4oN0%3D",
        },
        body: JSON.stringify(removeDiscountObj),
      }
    );

    const removePromoData = await checkHttpStatus(removePromoResponse);

    if (removePromoData.orderId && removePromoData.orderId.length) {
      const getCartItemsResponse = await fetch(
        `/wcs/resources/store/${storeId}/cart/@self`,
        {
          method: "GET",
          headers: jsonApiHeader(),
        }
      );
      const getCartData = await checkHttpStatus(getCartItemsResponse);
      if (
        getCartData &&
        getCartData.orderItem &&
        getCartData.orderItem.length
      ) {
        setLoadingCost(true);
        let updatedShoppingCartItems = [...shoppingCartItems];
        let currentIndexToBeUpdated = updatedShoppingCartItems.findIndex(
          (data) => data.orderItemId === orderItemId
        );
        const updatedItemObj = getCartData.orderItem.find(
          (data) => data.orderItemId === orderItemId
        );
        if (currentIndexToBeUpdated !== -1) {
          updatedShoppingCartItems[currentIndexToBeUpdated] = {
            ...updatedShoppingCartItems[currentIndexToBeUpdated],
            promocode: null,
            promoCode: null,
            promoDescription: null,
            promoError: null,
            percentageDiscount: null,
            unitPrice:
              updatedItemObj?.unitPrice ||
              updatedShoppingCartItems[currentIndexToBeUpdated].unitPrice,
          };
        }
        setShoppingCartItems(updatedShoppingCartItems);
        const totalProductPrice = parseFloat(getCartData.totalProductPrice);
        setTotalCost(
          Number.isFinite(totalProductPrice) ? totalProductPrice.toFixed(2) : "0.00"
        );
        setLoadingCost(false);
      }
    }
    setIsApplyDiscountButtonEnabled(false);
    //https://localhost/wcs/resources/store/10051/shopcart/removeDiscountCode
  };

  //331732%2Ck4yZiQb0HTZLjdMZWA1ir%2BYgz%2FEbUgTK6GJR7qISlhw%3D

  return (
    <div className="card-item-container">
      <div className="shopping-cart-card-content">
        {isBOB && isCartLocked ? (
          <input
            type="checkbox"
            name="cart-item-checkbox"
            id={`cart-item-checkbox-${productItem?.orderItemId}`}
            style={{
              visibility: "visible",
              display: "flex",
              alignItems: "start",
              justifyContent: "start",
              width: "25px",
              height: "25px",
              marginRight: "15px",
            }}
            value={productItem?.orderItemId}
            checked={Boolean(isSelected)}
            onChange={(event) =>
              onCheckboxChange(productItem?.orderItemId, event.target.checked)
            }
          />
        ) : null}
        <div className="shopping-cart-image-container">
          <img
            className="product-image"
            height="150px"
            width="150px"
            src={
              productItem.bandOrderData ? BandOrderImage : productItem.thumbnail
            }
            alt="thumbnail"
          />
        </div>
        <div className="product-details-wrapper">
          <div className="product-details">
            <div className="product-description">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div
                  className="prod-desc-info"
                  onClick={() => {
                    productItem.bandOrderData
                      ? bandFormLink(
                          productItem.bandOrderData.bandType,
                          productItem.bandOrderData.sequence,
                          productItem.bandOrderData.comments,
                          true
                        )
                      : redirectToproductPageLink(
                          productItem.parentCatalogEntryID,
                          productItem.bandOrderData,
                          productItem.parentCatalogGroupID
                        );
                  }}
                >
                  <div className="product-description-header">
                    {productItem.bandOrderData
                      ? productItem.bandOrderData.header
                      : splitProductDescription(
                          productItem.shortDescription,
                          true
                        )}
                  </div>
                  {productItem.bandOrderData ? (
                    <div className="product-description-header">
                      {productItem?.bandOrderData?.bandType} bands with
                      attachments
                    </div>
                  ) : null}
                  <div className="product-description-details">
                    {productItem.bandOrderData
                      ? productItem.bandOrderData.prescriptionType
                      : splitProductDescription(
                          productItem.shortDescription,
                          false
                        ) +
                        `, Prescriptions: ${productItem.prescriptionsAvailable}`}
                  </div>
                  {!productItem.bandOrderData ? (
                    <div className="part-number">{`Part #${productItem.partNumber}`}</div>
                  ) : null}
                </div>
                <div
                  className="product-price-qty"
                  style={{ flexDirection: "column", position: "relative" }}
                >
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <div className="product-unit-price">
                      {currencyFormatter.format(netUnitPriceValue)}
                    </div>
                    <span className="product-measurement">
                      {productItem.xitem_field2}
                    </span>
                  </div>
                  {!productItem.bandOrderData ? (
                    <>
                      {productItem.promoError &&
                      productItem.promoError.trim("").length > 0 ? (
                        <div
                          style={{
                            width: "100px",
                            marginTop: "25px",
                            position: "absolute",
                          }}
                          className="promo-code-error"
                        >
                          {productItem.promoError}
                        </div>
                      ) : null}
                      {!productItem.promoError && shouldShowListPrice ? (
                        <>
                          <div className="list-price">
                            <span className="list-price-label">
                              {translationKey(currentFileRequired["LIST_PRICE"])}:{" "}
                            </span>
                            <span className="list-price-value">
                              {currencyFormatter.format(listPriceValue)}
                            </span>
                          </div>
                          {hasPromoCode ? (
                            <div className="promo-code-description">
                              <span style={{ marginRight: "8px" }}>
                                {" "}
                                {productItem.promoDescription ||
                                  productItem.promoCode ||
                                  productItem.promocode}
                              </span>
                              <img
                                onClick={() =>
                                  removeDiscountCodeHandler(
                                    productItem.orderItemId
                                  )
                                }
                                style={{
                                  position: "absolute",
                                  right: "7px",
                                  marginTop: "3px",
                                  height: "10px",
                                }}
                                src={CloseIcon}
                              />
                            </div>
                          ) : null}
                        </>
                      ) : null}
                      <div className="total-unit-price">
                        <span className="total-unit-price-label">
                          {translationKey(currentFileRequired["TOTAL_PRICE"])}:{" "}
                        </span>
                        <span className="total-unit-price-value">
                          {currencyFormatter.format(totalUnitPriceValue)}
                        </span>
                      </div>
                      {!productItem.promoError && hasPromoCode ? (
                        <div className="discount-code">
                          <span className="discount-code-label">
                            Discount Code
                          </span>
                          <span className="discount-code-value">
                            {productItem.promoCode}
                          </span>
                        </div>
                      ) : null}
                      {!productItem.promoError &&
                      hasPromoCode &&
                      discountPercent !== null &&
                      discountPercent > 0 ? (
                        <div className="discount-percentage">
                          <span className="discount-percentage-label">
                            Discount
                          </span>
                          <span className="discount-percentage-value">
                            {discountPercent.toFixed(2)}%
                          </span>
                        </div>
                      ) : null}
                    </>
                  ) : null}{" "}
                </div>
              </div>
            </div>

            {productItem.bandOrderData ? (
              <>
                <div className="band-order-details-section">
                  <div>
                    <table className="band-prescription-table">
                      <tbody>
                        <tr>
                          <td>
                            <table className="band-prescription-inner-table">
                              <thead>
                                <td style={{ textAlign: "left" }}>
                                  {" "}
                                  {translationKey(currentFileRequired["TYPE"])}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {" "}
                                  {translationKey(currentFileRequired["SIZE"])}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {" "}
                                  {translationKey(
                                    currentFileRequired["QUANTITY"]
                                  )}
                                </td>
                              </thead>
                              <tbody>
                                {bandOrderItems.map(
                                  (itemData, itemIndex) => (
                                    <tr
                                      style={{ background: "transparent" }}
                                      key={itemIndex.toString()}
                                    >
                                      <td style={{ textAlign: "left" }}>
                                        {itemData.type}
                                      </td>
                                      <td style={{ textAlign: "left" }}>
                                        {itemData.size}
                                      </td>
                                      <td style={{ textAlign: "left" }}>
                                        {itemData.quantity}
                                      </td>
                                    </tr>
                                  )
                                )}
                                {bandOrderItems.length === 0 ? (
                                  <tr style={{ background: "transparent" }}>
                                    <td colSpan="3" style={{ textAlign: "left" }}>
                                      Band order details unavailable
                                    </td>
                                  </tr>
                                ) : null}
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div
                      className={`band-order-actions-container  ${
                        (isBOB && isCartLocked) || (!isBOB && !isCartLocked)
                          ? ""
                          : "d-none"
                      }`}
                    >
                      <a
                        className="edit-band-order-cart-item"
                        href={bandFormLink(
                          productItem.bandOrderData.bandType,
                          productItem.bandOrderData.sequence,
                          productItem.bandOrderData.comments
                        )}
                      >
                        {translationKey(currentFileRequired["EDIT_ORDER"])}
                      </a>
                      <span>|</span>
                      <a
                        onClick={() =>
                          deleteShoppingCartItem(
                            productItem,
                            productItem.bandOrderData.sequence
                          )
                        }
                        className="delete-band-order-cart-item"
                      >
                        {translationKey(currentFileRequired["DELETE"])}
                      </a>
                    </div>
                  </div>
                  <div className="comment-section">
                    <div className="band-order-header">
                      {" "}
                      {translationKey(currentFileRequired["COMMENTS"])}
                    </div>
                    <div className="band-order-sub-header">
                      {productItem.bandOrderData.comments}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div
                className={`add-delete-item-container  ${
                  (isBOB && isCartLocked) || (!isBOB && !isCartLocked)
                    ? ""
                    : "d-none"
                }`}
              >
                <div className="input-group">
                  <div
                    onClick={() =>
                      updateShoppingCartItemQuantity(
                        productItem.orderItemId,
                        "subtract",
                        2000
                      )
                    }
                    className="subtract-icon"
                  >
                    <img src={SubtractIcon} alt="subtract" />
                  </div>

                  <input
                    type="number"
                    key={parseInt(
                      updatedShoppingCartItems.find(
                        ({ orderItemId }) =>
                          productItem.orderItemId === orderItemId
                      ).orderItemId
                    ).toString()}
                    name={productItem.orderItemId}
                    className="quantity-field"
                    defaultValue={parseInt(
                      updatedShoppingCartItems.find(
                        ({ orderItemId }) =>
                          productItem.orderItemId === orderItemId
                      ).quantity
                    ).toFixed(0)}
                    id={productItem.orderItemId}
                    onChange={(e) => {
                      document
                        .getElementsByName(productItem.orderItemId)[0]
                        .setAttribute("value", parseInt(e.target.value));
                      updateQuantityWithInput(
                        e.target.value,
                        productItem.orderItemId,
                        updatedShoppingCartItems.findIndex(
                          ({ orderItemId }) =>
                            productItem.orderItemId === orderItemId
                        )
                      );
                    }}
                    onBlur={(e) => {
                      SaveInputQuantity(
                        e.target.value,
                        productItem.orderItemId,
                        updatedShoppingCartItems.findIndex(
                          ({ orderItemId }) =>
                            productItem.orderItemId === orderItemId
                        )
                      );
                    }}
                  />
                  <div
                    onClick={() =>
                      updateShoppingCartItemQuantity(
                        productItem.orderItemId,
                        "add",
                        2000
                      )
                    }
                    className="add-icon"
                  >
                    <img src={AddIcon} alt="add" />
                  </div>
                </div>
                <a
                  onClick={() => deleteShoppingCartItem(productItem)}
                  className="delete-cart-item"
                >
                  {translationKey(currentFileRequired["DELETE"])}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ShoppingCartCardItem;
